enum CustomerViewType {
    Guest = 'guest',
    Login = 'login',
    SuggestedLogin = 'suggested_login',
    EnforcedLogin = 'enforced_login',
    CancellableEnforcedLogin = 'cancellable_enforced_login',
    CreateAccount = 'create_account',
}

export default CustomerViewType;
